<template>
  <div>
    <SiteHero
      image="/media/kontakt-hero.webp"
      eyebrow="Dane kontaktowe"
      title="Skontaktuj się z nami"
      lead="Chętnie odpowiemy na pytania o ofertę, koszt importu konkretnego modelu lub wybraną aukcję."
      scroll-to="formularz"
    />

    <section class="site_section intro">
      <div class="site_container intro_grid">
        <div>
          <p class="site_eyebrow">Kontakt z Japonia Cars</p>
          <h2>Zadzwoń albo napisz</h2>
          <p class="intro_lead">
            Możesz skorzystać z kontaktu telefonicznego, mailowego lub formularza – staramy
            się odpowiadać tego samego dnia roboczego.
          </p>
        </div>
        <p>
          Niezależnie od tego, czy interesuje Cię pojazd dostępny w salonie, egzemplarz
          wystawiony w japońskim domu aukcyjnym, czy import na zamówienie – pomożemy
          oszacować całkowity koszt sprowadzenia auta, doradzimy w doborze modelu i
          przeprowadzimy przez kolejne etapy współpracy.
        </p>
      </div>
    </section>

    <section id="formularz" class="site_container form_grid">
      <SiteContactList :items="contacts" />

      <div class="form_card">
        <SiteContactForm />
      </div>
    </section>

    <section class="site_section">
      <div class="site_container">
        <div class="visit">
          <p class="site_eyebrow site_eyebrow--accent">Wizyta w salonie</p>
          <h2>
            Jeżeli planujesz wizytę w salonie, prosimy o telefoniczne potwierdzenie
            dostępności pojazdu, którym jesteś zainteresowany.
          </h2>
          <p class="visit_lead">
            Pozwoli to przygotować auto do oględzin oraz zarezerwować czas naszego specjalisty
            wyłącznie dla Ciebie. Zapraszamy także do śledzenia naszych kanałów
            społecznościowych, gdzie regularnie publikujemy nowości w ofercie, relacje z
            odbiorów oraz informacje o świeżo sprowadzonych egzemplarzach.
          </p>
          <p class="visit_phones">
            <a href="tel:+48509230500"><PhoneIcon /> Tel. 509 230 500</a>
            <a href="tel:+48501069442"><PhoneIcon /> Tel. 501 069 442</a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import pageHead from '@/mixins/pageHead'
import { pageSchema } from '@/utils/schema'
import SiteHero from '@/components/SiteHero.vue'
import SiteContactList from '@/components/SiteContactList.vue'
import SiteContactForm from '@/components/SiteContactForm.vue'
import PhoneIcon from '@/components/icons/PhoneIcon.vue'

export default {
  name: 'KontaktPage',
  components: { SiteHero, SiteContactList, SiteContactForm, PhoneIcon },
  mixins: [pageHead],

  pageHead: {
    title: 'Kontakt - Japonia Cars',
    description:
      'Skontaktuj się z Japonia Cars — telefon, e-mail i formularz zapytania o import auta z Japonii.',
    schema: pageSchema({
      path: '/kontakt/',
      name: 'Kontakt',
      breadcrumbs: [{ name: 'Kontakt' }],
      published: '2026-05-12T05:53:20+00:00',
      modified: '2026-06-08T11:58:13+00:00',
    }),
  },

  data() {
    return {
      contacts: [
        { icon: 'phone', title: 'Numer telefonu', value: 'Tel. 509 230 500', href: 'tel:+48509230500' },
        { icon: 'phone', title: 'Numer telefonu', value: 'Tel. 501 069 442', href: 'tel:+48501069442' },
        { icon: 'mail', title: 'Adres e-mail', value: 'kontakt@japoniacars.pl', href: 'mailto:kontakt@japoniacars.pl' },
        { icon: 'pin', title: 'Lokalizacja biura', value: '43-100 Tychy, Ul. Wałowa 32' },
        { icon: 'clock', title: 'Godziny otwarcia', value: 'Pon. – pt. 9:00 – 18:00' },
      ],
    }
  },
}
</script>

<style scoped>
.intro {
  padding-bottom: 32px;
}

.intro_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: end;
}

.intro h2 {
  margin: 15px 0 22.5px;
}

.intro_lead {
  max-width: 543px;
}

.form_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
  padding-bottom: 80px;
}

.form_card {
  padding: 16px;
  border-radius: var(--radius);
  background: var(--ink);
}

.visit {
  padding: 48px 32px;
  border-radius: var(--radius);
  background: var(--ink);
  color: var(--ink-invert-soft);
  text-align: center;
}

.visit h2 {
  max-width: 1000px;
  margin: 15px auto 22.5px;
  color: var(--ink-invert);
}

.visit .site_eyebrow {
  justify-content: center;
}

.visit_lead {
  max-width: 1140px;
  margin: 0 auto 32px;
}

.visit_phones {
  display: flex;
  justify-content: center;
  gap: 32px;
  color: #fff;
}

.visit_phones a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 1024px) {
  .intro_grid,
  .form_grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .visit {
    padding: 32px 20px;
  }

  .visit_phones {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}
</style>
